import { H1, H2, H3, P, Span } from './Styles'

interface TextProps {
  H1: typeof H1
  H2: typeof H2
  H3: typeof H3
  P: typeof P
  Span: typeof Span
}

export const Text: TextProps = {
  H1,
  H2,
  H3,
  P,
  Span,
}

export default Text
